import { render, staticRenderFns } from "./PrivacyPage.vue?vue&type=template&id=30174082"
import script from "./PrivacyPage.vue?vue&type=script&lang=js"
export * from "./PrivacyPage.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPage.vue?vue&type=style&index=0&id=30174082&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports